module.exports = __webpack_public_path__ + "img/bean_500.6732d3b0.png";